import { Chip } from '@mui/material';
import { DeviceLabel } from '../../../types/DeviceLabel';
import { ReaderLabel } from '../../../types/ReaderLabel';

const getContrastYIQ = (hexcolor: string) => {
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
};

interface DisplayLabelProp {
  labels?: DeviceLabel[] | ReaderLabel[];
}

const DisplayLabels = (props: DisplayLabelProp) => {
  return props.labels?.map((label) => (
    <Chip
      key={label.id}
      label={label.name}
      style={{
        height: 20,
        color: getContrastYIQ(label.colorRgb),
        backgroundColor: label.colorRgb,
        textAlign: 'left',
      }}
      size='small'
      variant='outlined'
    />
  ));
};
export default DisplayLabels;
